import React, { useEffect } from "react";
import "./industries.scss";
function Industries(props) {
  return (
    <>
      <section>
        <h1> <span className="page-title border-small">Industries We Serve</span></h1>
        <div className="container-fluid">{props.children}</div>
      </section>
    </>
  );
}

export default Industries;
